import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import FormGroup from '@material-ui/core/FormGroup';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import FormDisplay from './FormDisplay';
import OutlinedSelect from '../controls/OutlinedSelect';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '../controls/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import FileUpload from '../controls/FileUpload';
import PhotoUpload from '../controls/PhotoUpload';
import Collapse from '@material-ui/core/Collapse';
import MaskedTextField from '../controls/MaskedTextField';
import emailMask from 'text-mask-addons/dist/emailMask';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import FormControlInfo from '../controls/FormControlInfo';
import IconButton from '@material-ui/core/IconButton';
import FieldList from './FieldList';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import format from 'date-fns/format';
import ReactMarkdown from 'react-markdown';
import { Alert, AlertTitle } from '@material-ui/lab';
import DialogContentText from '@material-ui/core/DialogContentText';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import Tooltip from '@material-ui/core/Tooltip';

const styles = (theme) => ({
    button: {
        maxWidth: 100,
    },

    control: {
        backgroundColor: '#ffffff',
    },
    alertIcon: {
        display: 'none',
    },
    iconButton: {
        padding: theme.spacing(0.5),
    },
    datePickerIcon: {
        padding: 0,
    },
    applyTextEllipsis: {
        whiteSpace: 'nowrap',
        width: 'calc(100% - 3rem)',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    removeTextEllipsis: {
        whiteSpace: 'unset',
        width: 'initial',
        overflow: 'unset',
        textOverflow: 'unset',
    },
});

class FormField extends React.PureComponent {
    state = {
        dialogOpen: false,
        dialogValue: '',
        value: '',
        infoField: '',
        infoContent: '',
    };

    processDateChange = () => {
        return null;
    };

    handleChange = (event) => {
        const val = event.target.value;
        this.setState({
            value: val,
        });
    };

    handleAddClick = () => {
        this.setState({ dialogOpen: true, dialogValue: '' });
    };

    handleCloseDialog = () => {
        this.setState({ dialogOpen: false });
    };

    handleAddListValue = (event) => {
        this.setState({ dialogOpen: false });

        event.preventDefault();

        return false;
    };

    handleInfoClick = () => {
        this.handleInfoDialog(this.props.field.label, this.props.field.additionalInfo);
    };

    handleInfoDialog = (field, content) => {
        this.setState({ infoField: field, infoContent: content });
    };

    handleInfoDialogClose = () => {
        this.setState({ infoField: '', infoContent: '' });
    };

    render() {
        let control = null;
        const dateMask = format(new Date(2020, 12, 31), 'P').replace(/[0-9][0-9]/g, '__');
        const labelClasses = {
            outlined: this.props.classes.applyTextEllipsis,
            shrink: this.props.classes.removeTextEllipsis,
        };

        switch (this.props.field.typeId) {
            case 'multiple':
                control = (
                    <React.Fragment>
                        <FieldList />
                        <Button
                            variant="contained"
                            className={this.props.classes.button}
                            onClick={() => this.handleAddClick(this.props.field.field)}
                        >
                            Add
                        </Button>
                        <Dialog open={this.state.dialogOpen} onClose={this.handleCloseDialog} fullWidth>
                            <form onSubmit={this.handleAddListValue}>
                                <DialogTitle>{this.props.field.label}</DialogTitle>
                                <DialogContent>
                                    <FormDisplay subEntries={this.props.subEntries} />
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={this.handleCloseDialog}>Cancel</Button>
                                    <Button type="submit">Add</Button>
                                </DialogActions>
                            </form>
                        </Dialog>
                    </React.Fragment>
                );
                break;
            case 'textBlock':
                control = <ReactMarkdown source={this.props.field.text} />;
                break;
            case 'choices':
                control = (
                    <OutlinedSelect
                        id={this.props.field.field}
                        className={this.props.classes.control}
                        labelClasses={labelClasses}
                        label={this.props.field.label}
                        value={this.props.value}
                    >
                        {this.props.field.choices &&
                            this.props.field.choices.map((choice) => (
                                <MenuItem key={choice.value} value={choice.value}>
                                    {choice.label}
                                </MenuItem>
                            ))}
                    </OutlinedSelect>
                );
                break;
            case 'boolean':
                control = (
                    <FormControlLabel
                        label={this.props.field.label}
                        control={
                            <Checkbox
                                id={this.props.field.field}
                                name={this.props.field.field}
                                checked={this.props.field.initialValue}
                            />
                        }
                    />
                );
                break;
            case 'fileUpload':
                control = <FileUpload className={this.props.classes.control} disabled={true} />;
                break;
            case 'photoUpload':
                control = <PhotoUpload className={this.props.classes.control} disabled={true} />;
                break;
            case 'date':
                control = (
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                            variant="inline"
                            inputVariant="outlined"
                            inputProps={{
                                'aria-label': 'Pick a Date',
                            }}
                            format="P"
                            margin="normal"
                            autoOk="true"
                            mask={dateMask}
                            value={null}
                            label={this.props.field.label}
                            InputLabelProps={{
                                classes: labelClasses,
                            }}
                            onChange={this.processDateChange}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                                className: this.props.classes.datePickerIcon,
                            }}
                            leftArrowButtonProps={{ 'aria-label': 'previous month' }}
                            rightArrowButtonProps={{ 'aria-label': 'next month' }}
                        />
                    </MuiPickersUtilsProvider>
                );
                break;
            case 'alert':
                control = (
                    <Alert
                        severity={this.props.field.alertType}
                        {...(this.props.field.width <= 2 && {
                            classes: { icon: this.props.classes.alertIcon },
                        })}
                    >
                        <AlertTitle>{this.props.field.title}</AlertTitle>
                        {this.props.field.text}
                    </Alert>
                );
                break;
            case 'system':
                control = (
                    <Grid container alignItems="center" spacing={2}>
                        <Grid item>
                            <Tooltip
                                title="System field is hidden from applicants"
                                enterDelay={200}
                                disableFocusListener={true}
                            >
                                <VisibilityOffIcon color="action" fontSize="large" />
                            </Tooltip>
                        </Grid>
                        <Grid item>
                            <Typography variant="h6" color="textPrimary">
                                {this.props.field.field}
                            </Typography>
                        </Grid>
                    </Grid>
                );
                break;
            default:
                if (this.props.field.mask) {
                    let mask;

                    switch (this.props.field.mask) {
                        case 'email':
                            mask = emailMask;
                            break;

                        default:
                            mask = this.props.field.mask;
                            break;
                    }

                    control = (
                        <MaskedTextField
                            className={this.props.classes.control}
                            labelClasses={labelClasses}
                            id={this.props.field.field}
                            name={this.props.field.field}
                            label={this.props.field.label}
                            onChange={this.handleChange}
                            mask={mask}
                        />
                    );
                } else {
                    control = (
                        <TextField
                            className={this.props.classes.control}
                            id={this.props.field.field}
                            name={this.props.field.field}
                            label={this.props.field.label}
                            instructions={this.props.field.instructions}
                            variant="outlined"
                            margin="dense"
                            onChange={this.handleChange}
                            value={this.props.value}
                            InputLabelProps={{
                                classes: labelClasses,
                            }}
                        />
                    );
                }
                break;
        }

        const controlGroup = (
            <React.Fragment>
                <FormGroup>
                    <Typography inline={'true'}>{this.props.field.instructions}</Typography>
                    <FormControlInfo
                        info={
                            this.props.field.additionalInfo && (
                                <IconButton
                                    aria-label="Additional Information"
                                    className={this.props.classes.iconButton}
                                    onClick={this.handleInfoClick}
                                >
                                    <InfoIcon color="secondary" />
                                </IconButton>
                            )
                        }
                    >
                        {control}
                    </FormControlInfo>
                </FormGroup>
                <Dialog open={Boolean(this.state.infoContent)} onClose={this.handleInfoDialogClose} maxWidth="md">
                    <DialogTitle>{this.state.infoField}</DialogTitle>
                    <DialogContent>
                        <DialogContentText dangerouslySetInnerHTML={{ __html: this.state.infoContent }} />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleInfoDialogClose}>Close</Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );

        if (this.props.visible === undefined) {
            return controlGroup;
        }

        return (
            <Collapse in={this.props.visible} timeout={{ enter: 800, exit: 300 }}>
                {controlGroup}
            </Collapse>
        );
    }
}

export default withStyles(styles)(FormField);
